import React from "react";
import {useState} from "react";
import styled from "styled-components";
import {logEvent} from "../../utils/analytics";
import {CheckCircle, ExclamationTriangle, Refresh} from "../icons";

const Form = styled.form`
  display: grid;
  grid-gap: 20px;
  width: 100%;
  align-items: center;

  h2 {
    margin-bottom: 0;

    &:first-child {
      margin-top: 0;
    }
  }

  fieldset {
    border: 0;
    padding: 0;
    margin: 0;

    &[disabled] {
      opacity: 0.5;
    }
  }

  input:not([type="checkbox"]),
  textarea,
  select {
    width: 100%;
    padding: 0.5rem;
    font-size: 1.8rem;
    border-radius: 2px;
    padding: 0.8rem;
    border: 2px solid transparent;
    font-family: ${props => props.theme.font};
    background-color: ${props => props.theme.veryLightGrey};

    ::placeholder {
      color: ${props => props.theme.grey};
    }

    :hover {
      box-shadow: ${props => props.theme.shadow};
    }

    &:focus {
      outline: 0;
      border-color: ${props => props.theme.lightGrey};
      box-shadow: ${props => props.theme.shadow};
    }
  }

  .react-select input,
  .react-select input:hover,
  .react-select input:focus {
    border: 0;
    box-shadow: none;
  }

  label {
    font-size: 1.2rem;
    margin-bottom: 10px;
    display: inline-block;
  }

  .inline {
    display: flex;
    align-items: center;

    > * {
      margin: 0 10px 0 0;
      cursor: pointer;
    }

    label {
      font-size: 1.4rem;
    }
  }

  span {
    font-size: 1.6rem;
    display: block;
    min-height: 20px;
  }

  footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.noonification-form {
    color: #ffffff;
    // display: flex;
    // flex-direction: column;
    // grid-gap: 0;
    text-align: center;
    // border: 2px solid black;
    @media (min-width: 768px) {
      text-align: left;
      width: auto;
    }
    h2 {
      margin: 0;
      font-family: "HackerNoon", sans-serif;
      color: #00ff00;
      font-size: 16px;
      @media (min-width: 576px) {
        font-size: 35px;
        line-height: 25px;
      }
    }
    p {
      margin: 0;
      font-size: 12px;
      line-height: 16px;
      font-style: italic;
      text-align: center;
      color: #fff;
    }
    label {
      margin: 0;
    }
    .noonification-form-input {
      background: #003b00;
      border: 1px solid #6df36d;
      padding: 8px 10px;
      border-radius: 0;
      font-size: 16px;
      font-weight: bold;
      transition: all 120ms ease-in-out;
      outline: none;
      color: #e5e5e5;
      width: 100%;
      height: 38px;
      text-align: center;
      @media (min-width: 576px) {
        width: 350px;
      }
      @media (min-width: 768px) {
        text-align: left;
      }
    }
  }

  &.newsletter-form {
    color: #ffffff;
    display: flex;
    flex-direction: column;
    grid-gap: 0;
    text-align: center;
    align-items: flex-start;

    div {
      display: flex;
    }

    @media (min-width: 768px) {
      text-align: left;
      width: auto;
    }
    h2 {
      margin: 0;
      font-family: "HackerNoon", sans-serif;
      font-weight: 400;
      color: #00ff00;
      font-size: 18px;
      line-height: 1.2;
      @media (min-width: 576px) {
        font-size: 20px;
      }
    }
    p {
      margin: 20px 0;
      font-size: 12px;
      line-height: 16px;
      font-style: italic;
      color: #ffffff;
    }
    label {
      margin-bottom: 0;
    }
    .newsletter-form-input {
      background: #2a2a2a;
      border: 1px solid #9ca3af;
      padding: 12px;
      border-radius: 6px;
      font-size: 16px;
      font-weight: bold;
      transition: all 120ms ease-in-out;
      outline: none;
      color: #e5e5e5;
      width: 100%;
      text-align: left;
    }
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  font-size: 1.8rem;
  border-radius: 2px;
  padding: 0.8rem;
  border: 2px solid transparent;
  font-family: ${props => props.theme.font};
  background-color: ${props => props.theme.veryLightGrey};

  ::placeholder {
    color: ${props => props.theme.lightGrey};
  }

  :hover {
    box-shadow: ${props => props.theme.shadow};
  }

  &:focus {
    outline: 0;
    border-color: ${props => props.theme.lightGrey};
    box-shadow: ${props => props.theme.shadow};
  }
`;

const SubscriptionField = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 24px;

  .newsletter-form-input {
    border: 1px solid #9ca3af !important;
    background: #2a2a2a !important;
    width: 100% !important;
    @media (max-width: 500px) {
      font-size: 16px !important;
    }
  }

  .newsletter-form-button {
    border: 1px solid white !important;
    border-left: 0px;
    margin: 0px;
    background: #00ff00;
    color: black;
    font-size: 12px;
    font-weight: bold;
    min-width: 50px;
    line-height: 15px;

    @media (max-width: 400px) {
      font-size: 3vw !important;
      padding: 5px;
    }

    :hover {
      background: darkGreen;
      color: white;
    }
  }
`;

const StyledRequiredField = styled.label`
  color: #e5e7eb;
  font-size: 12px !important;
  display: flex !important;
  align-items: center;
  font-style: italic;
  font-weight: 400;
  line-height: 13px;
  input {
    margin-right: 5px;
    @media (min-width: 576px) {
      align-items: center;
    }
  }
  span {
    color: #e5e7eb;
    font-size: 10px;
    margin: 0 0.5rem;
    font-weight: bolder;
  }

  @media (max-width: 500px) {
    font-weight: 400;
    font-size: 12px !important;
    margin-top: 1rem;
    width: 100% !important;
  }
`;

const StyledFormResponse = styled.div`
  background-color: #f0ad4e;
  color: #e5e7eb;
  text-align: center;
  font-size: 16px;
  border-radius: 3px;
  padding: 5px;
  &.success {
    background-color: #5cb85c;
  }
`;
const Button = styled.button`
  background: #00ff00;
  color: #1e1e1e;
  font-size: 20px;
  font-weight: bold !important;
  width: 100%;
  padding: 12px;
  margin: 16px 0 8px 0;
  border: none;
  border-radius: 6px;
  transition: 0.3s;
  :hover {
    background: #00dd00;
    cursor: pointer;
  }
  @media (max-width: 500px) {
    width: 100% !important;
    font-size: 16px !important;
  }
`;

const SubscriptionForm = ({colors, tag, staticData = {}}) => {
  if (colors?.colors) {
    colors = colors.colors;
  }
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitStatus, setSubmitStatus] = useState();

  const handleNewsletterSubscription = event => {
    event.preventDefault();
    setLoading(true);

    logEvent("Email Subscription", `${email} subscribed to newsletter`);

    const lists = tag ? [14497] : [14440, 14498, 14497];

    fetch("https://internal.hackernoon.com/subscription/public-subscribe", {
      //fetch("http://localhost:8080/public-subscribe", {
      method: "PUT",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        email: email,
        tag,
        lists,
      }),
    })
      .then(response => {
        setSubmitted(true);
        setSubmitStatus(response.status);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form style={{width: "100%"}} className="newsletter-form" onSubmit={handleNewsletterSubscription}>
      <div style={{width: "100%"}}>
        <h2>{staticData.newsletterHeader || "The HackerNoon Newsletter"}</h2>
      </div>
      {submitStatus && (
        <StyledFormResponse className={submitStatus == 200 ? "success" : null}>
          {submitStatus == 200 ? (
            <>
              <CheckCircle /> Form Successfully Submitted
            </>
          ) : (
            <>
              <ExclamationTriangle /> Form Failed to Submit
            </>
          )}
        </StyledFormResponse>
      )}
      <SubscriptionField>
        <label style={{width: "100%"}}>
          <Input
            placeholder="you@email.com"
            name="email"
            type="email"
            required
            className="newsletter-form-input"
            value={email}
            style={{width: "100%", border: "1px solid #9ca3af", borderRadius: "6px", padding: "12px"}}
            onChange={e => {
              setEmail(e.currentTarget.value);
            }}
          />
        </label>
      </SubscriptionField>

      <Button style={{fontWeight: "bold"}} className="newsletter-form-button">
        {loading ? <Refresh /> : submitted ? "Subscribed" : "Subscribe"}
      </Button>
      <StyledRequiredField style={{width: "100%"}}>
        <input type="checkbox" required name="agreed" />{" "}
        {staticData.checkboxCopy || "I agree to receive electronic content from HackerNoon"}
      </StyledRequiredField>
    </Form>
  );
};

export default SubscriptionForm;
